/**
 * YouTube platform detection + client-side creator share (until contract % is server-driven).
 * Optional: REACT_APP_YOUTUBE_PLATFORM_IDS=comma,separated,platform_ids
 */
function youtubePlatformIds() {
  return (process.env.REACT_APP_YOUTUBE_PLATFORM_IDS || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

export function isYoutubePlatform(platformId, displayName) {
  const ids = youtubePlatformIds();
  if (platformId && ids.includes(platformId)) return true;
  return /youtube/i.test(String(displayName || ""));
}

/** Whether the SQL-backed platform list includes YouTube for navigation / copy. */
export function projectHasYoutubePlatform(platformList) {
  return (platformList || []).some((p) =>
    isYoutubePlatform(p.id, p.display_name)
  );
}

const DEFAULT_CREATOR_SHARE = 0.65;
const YOUTUBE_CREATOR_SHARE = 0.5;

export function creatorShareRate(platformId, displayName) {
  return isYoutubePlatform(platformId, displayName)
    ? YOUTUBE_CREATOR_SHARE
    : DEFAULT_CREATOR_SHARE;
}

export function netPayoutFromRevenue(revenue, platformId, displayName) {
  return creatorShareRate(platformId, displayName) * (Number(revenue) || 0);
}
